import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ArticleTeaser() {
  const { t } = useTranslation();

  return (
    <section id="guide" className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="overflow-hidden rounded-3xl border border-background-200 bg-gradient-to-br from-background-50 to-secondary-50">
        <div className="grid grid-cols-1 md:grid-cols-5">
          <div className="md:col-span-3 p-8 md:p-10">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-bold text-primary-700">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-article-line text-sm" aria-hidden="true"></i>
              </span>
              {t("article.title")}
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">{t("nav.guides")}</h2>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-foreground-600">{t("article.text")}</p>
            <Link
              to="/usfans-spreadsheet-guide"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              {t("article.cta")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </span>
            </Link>
          </div>
          <div className="relative md:col-span-2">
            <div className="h-48 w-full md:h-full">
              <img
                src="https://readdy.ai/api/search-image?query=An%20open%20hardcover%20notebook%20with%20a%20pen%20and%20a%20pair%20of%20reading%20glasses%20on%20a%20light%20warm%20beige%20surface%2C%20a%20small%20stack%20of%20books%20nearby%2C%20soft%20window%20light%2C%20calm%20editorial%20photography%2C%20high%20detail%2C%20no%20readable%20text&width=640&height=480&seq=article-teaser-01&orientation=portrait&nocache=true"
                alt="USFans guide"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}